export class ApiError extends Error {
  constructor(message, options = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = options.status;
    this.problem = options.problem;
    this.traceId = options.traceId;
  }
}

export async function parseApiError(response, fallbackMessage = 'The request failed.') {
  const problem = await readProblemDetails(response);
  const statusMessage = response?.status ? `Request failed (${response.status})` : fallbackMessage;
  const message = problem?.detail || problem?.title || fallbackMessage || statusMessage;

  return new ApiError(message, {
    status: response?.status,
    problem,
    traceId: problem?.traceId,
  });
}

async function readProblemDetails(response) {
  if (!response || typeof response.json !== 'function') {
    return null;
  }

  const contentType = response.headers?.get?.('content-type') || '';
  const expectsProblemJson = contentType.toLowerCase().includes('application/problem+json');

  try {
    const payload = await response.json();
    if (!payload || typeof payload !== 'object') {
      return null;
    }

    if (expectsProblemJson || payload.title || payload.detail || payload.errors) {
      return payload;
    }
  } catch (_) {
    return null;
  }

  return null;
}
